import React from "react";
import { BaseFragAnnouncerPack } from "./BaseFragAnnouncerPack";
import { MessageAnimationContext } from "../../../../client/components/MultiPlayer/messageAnimations";
import FragFireworksAnimation from "../../../../client/components/MultiPlayer/animations/FragFireworksAnimation";

/**
 * Fireworks frag announcer pack
 * Uses fireworks animation for frag events (victims only), text for fraggers
 */
export default class FireworksFragAnnouncerPack extends BaseFragAnnouncerPack {
  getAudio(eventType: string): string | null {
    if (eventType === "frag") {
      // Placeholder: replace with real audio path when available
      return null;
    }
    return null;
  }

  protected getVictimHandler(
    context: MessageAnimationContext
  ): React.ReactElement {
    return FragFireworksAnimation(context);
  }
}

